module.exports = __webpack_public_path__ + "static/img/PicoJet_330.4280bb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PicoJet_330.jpg
// module id = 01b9
// module chunks = 0